import { NEXT_STEPS, JOIN_URL } from "@/content/nextSteps";

function SectionHeading({ heading, sub }) {
    return (
        <>
            <h2 className="font-display text-2xl font-bold text-primary sm:text-3xl">{heading}</h2>
            {sub && <p className="mt-2 text-lg text-foreground/80">{sub}</p>}
        </>
    );
}

export default function WhatYouKnowNextSteps() {
    return (
        <section className="bg-surface-2" data-testid="next-steps-section">
            <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
                <SectionHeading heading={NEXT_STEPS.heading} sub={NEXT_STEPS.sub} />
                <ol className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="next-steps-list">
                    {NEXT_STEPS.steps.map((s, i) => (
                        <li key={s.title} className="flex flex-col overflow-hidden rounded-lg border border-border bg-white">
                            <span className="h-1.5 w-full bg-primary" aria-hidden="true" />
                            <div className="flex flex-1 flex-col p-6">
                                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary font-display text-lg font-bold text-white" aria-hidden="true">{i + 1}</span>
                                <h3 className="mt-4 text-lg font-bold">{s.title}</h3>
                                <p className="mt-1 flex-1 text-base text-foreground/80">{s.text}</p>
                                <span className="mt-4 text-xs font-semibold uppercase tracking-wider text-muted-foreground">{s.who}</span>
                                {s.button && (
                                    <a
                                        href={JOIN_URL}
                                        data-testid="next-steps-join-btn"
                                        className="mt-4 inline-flex w-full items-center justify-center rounded-lg bg-primary px-5 py-2.5 text-base font-semibold text-white transition-colors hover:bg-primary/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
                                    >
                                        {s.button}
                                    </a>
                                )}
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
